import Phaser from "phaser";

//let player
const externalHost = `https://xelestech.com/`
const category1 = 0b0001
const category2 = 0b0010
const category3 = 0b0100
let offX = 450
let offY = 400
var centerX
var centerY
var talkerSpine
const npcList = ["npcChief","npcFarmer","npcKnight"]

export default class TalkZone{

  constructor(scene, width, height, talkerSpine,image) {
    scene.load.image('empty_image', `${externalHost}assets/box_invi.png`);
    centerX = talkerSpine.x+offX;
    centerY = talkerSpine.y+offX;
    this.talkerSpine = talkerSpine


    var bodies = Phaser.Physics.Matter.Matter.Bodies;
    //var bodyCollision = bodies.circle(playerX, playerY+100, 24, { isSensor: false, label: 'playerCollision' });
    var bodySensor = bodies.circle(centerX, centerY, 150, { isSensor: true, label: 'playerSensor' });
    this.player = scene.matter.add.image(centerX, centerY, "empty_image"
    );
    this.player.setCollisionCategory(category1);
    this.player.setCollidesWith(category2);
    // player.body.collisionFilter.group = 1
    // player.body.collisionFilter.mask = 0

    this.player.setExistingBody(bodySensor);
    // player.setBody({
    //     type: 'circle',
    //     radius: 36
    // });
    //scene.add(this.circle(centerX,centerY,100))
    console.log("wow insisde talkerzone")
    //scene.matter.world.add(this);
    //this.body.setAllowGravity(false);
    //this.body.moves = false;
    //scene.add.existing(this);

    scene.sys.events.on("update", this.update, this);

    this.talkerSpine = talkerSpine;
    this.lastNpc = null;

    //this.body.onOverlap = true;
    this.listener = scene.matter.world.on(
      Phaser.Physics.Matter.Events.COLLISION_START,
      this.handleTouch,
      this
    );
  }

  update() {
    var centerX = this.talkerSpine.x+offX;
    var centerY = this.talkerSpine.y+offY;

    if(this.talkerSpine.scale > 0){
      centerX = this.talkerSpine.x+offX;
      centerY = this.talkerSpine.y+offX;
  }else{
      centerX = this.talkerSpine.x-offX;
      centerY = this.talkerSpine.y+offX;
  }
    this.player.x = centerX;
    this.player.y = centerY;
  }

  handleTouch(zone,collision1,collision2) {

    if ((collision1.label !== "playerSensor" && collision2.label !== "npcSensor")
        || collision1.label !== "npcSensor" && collision2.label !== "playerSensor"){
      console.log("touching")
      if(collision1.label == "playerSensor"){
        this.lastNpc = collision2;
      }else{
        this.lastNpc = collision1;
      }
      console.log(collision2)
      console.log(collision1)
      console.log(zone)
      return true
    }else{
      console.log(collision1.label)
      console.log(collision2.label)
      return false; 
    }


  }

  getLastNpcName() {
    if(npcList.includes(this.lastNpc.gameObject.getData("npcName"))){
      return this.lastNpc.gameObject.getData("npcName");
    }else{
      return "tommy"
    }
  }

  // isNPCToTheRightOfTalker() {
  //   return this.talkerSprite.body.centerX < this.lastNpc.body.centerY;
  // }

  shutdown() {}

  destroy(fromScene = false) {
    this.shutdown();
    this.scene.sys.events.off("update", this.update, this);

    super.destroy(fromScene);
  }
}
